import { styled } from '@mui/system'
import MuiGrid from '@mui/material/Grid'
import Swatch, { TextSwatch } from '../../molecules/swatch'

const shouldForwardProp = (prop) => !['itemLength'].includes(prop)

const WrapperContent = styled(MuiGrid)`
	overflow: auto;
`

const AttributesWrapper = styled(MuiGrid)`
	flex-grow: 1;
	width: auto;
	border-bottom: 1px solid ${({ theme }) => theme.palette.grey.main};
	&:last-child {
		border-bottom: none;
	}
`
const AttributesWrapper2 = styled(MuiGrid, { shouldForwardProp })`
	width: ${({ itemLength }) => (itemLength === 1 ? '100%' : 'auto')};
	flex-grow: 1;
	border-bottom: 1px solid ${({ theme }) => theme.palette.grey.main};
	padding: 10px 0;
	&:last-child {
		border-bottom: none;
	}
`

const TextSwatchStyled = styled(TextSwatch)`
	pointer-events: none;
	padding: 0;
	min-height: auto;
	min-width: auto;
	margin-bottom: 0;
`

const SwatchStyled = styled(Swatch)`
	pointer-events: none;
	margin-bottom: 0;
`

const ActionCloseWrapper = styled('div', { shouldForwardProp })`
	position: ${({ itemLength }) => (itemLength === 0 ? 'absolute' : 'fixed')};
	right: ${({ itemLength }) => (itemLength === 0 ? '0' : '10px')};
	top: 0;
	z-index: 1;
`

const TitleWrapper = styled('div')`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 40px 0;
`

const WrapperAttributeCode = styled('div')`
	padding-left: 40px;
	padding-right: 10px;
	width: 150px;
	${({ theme }) => theme.breakpoints.up('md')} {
		width: 250px;
	}
	${({ theme }) => theme.breakpoints.up('md')} {
		width: 350px;
	}
`
const WrapperAttributeValue = styled('div')`
	padding: 0 10px;
	display: flex;
	&:last-of-type {
		padding-right: 40px;
	}
	width: 150px;
	${({ theme }) => theme.breakpoints.up('md')} {
		width: 250px;
	}
	${({ theme }) => theme.breakpoints.up('md')} {
		width: 350px;
	}
`

const MuiGridNoProducts = styled(MuiGrid)`
	text-align: center;
	padding: 0 0 40px;
`

export {
	WrapperContent,
	AttributesWrapper,
	TextSwatchStyled,
	SwatchStyled,
	ActionCloseWrapper,
	TitleWrapper,
	AttributesWrapper2,
	WrapperAttributeCode,
	WrapperAttributeValue,
	MuiGridNoProducts,
}
